import { render, staticRenderFns } from "./user_removed_successfully.vue?vue&type=template&id=1bf53366&scoped=true"
import script from "./user_removed_successfully.vue?vue&type=script&lang=js"
export * from "./user_removed_successfully.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf53366",
  null
  
)

export default component.exports